module.exports = "<p>\n  select-loop works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/select-loop/select-loop.component.html
// module id = 1524
// module chunks = 2